import * as types from './actionTypes';

export function handleLoggedInUser(payload) {
  return {
    type: types.HANDLE_LOGGED_IN,
    payload
  }
};

export function handleLoggedOutUser(payload) {
  return {
    type: types.HANDLE_LOGGED_OUT,
    payload
  }
};


export function handleFormStep(payload) {
  return {
    type: types.HANDLE_FORM_STEP,
    payload
  }
};

export function getCountry(payload) {
  return {
    type: types.GET_COUNTRY,
    payload
  }
};
export function getState(payload) {
  return {
    type: types.GET_STATE,
    payload
  }
};
export function saveStepSuccessForLoggedIn(payload) {
  return {
    type: types.SAVE_STEP_SUCCESS_FOR_LOGGED_IN,
    payload
  }
};
export function saveStepSuccessForLoggedOut(payload) {
  return {
    type: types.SAVE_STEP_SUCCESS_FOR_LOGGED_OUT,
    payload
  }
};


export function saveAppSuccess(payload) {
  return {
    type: types.SAVE_APP_SUCCESS,
    payload
  }
};
export function setSavedData(payload) {
  return {
    type: types.SET_SAVED_DATA,
    payload
  }
};
export function handleFormLoader(payload) {
  return {
    type: types.HANDLE_FORM_LOADER,
    payload
  }
};
export function handleSaveFormLoader(payload) {
  return {
    type: types.HANDLE_SAVE_FORM_LOADER,
    payload
  }
};
export function storeSavedData(payload) {
  return {
    type: types.STORE_SAVED_DATA,
    payload
  }
};
export function applicationSubmitted(payload) {
  return {
    type: types.APP_SUBMITTED,
    payload
  }
};

export function handleProgramSelection(payload) {
  return {
    type: types.HANDLE_PROGRAM_SELECTION,
    payload
  }
};